import React from 'react';
import './Grid.css';

type StyleWithVars = React.CSSProperties & Record<`--${string}`, string | number | undefined>;

export type WxbGridGap = 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type WxbGridAlign = 'start' | 'center' | 'end' | 'stretch';
export type WxbGridJustify = 'start' | 'center' | 'end' | 'between';
export type WxbColSpan = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface WxbRowProps extends React.HTMLAttributes<HTMLDivElement> {
  gap?: WxbGridGap;
  align?: WxbGridAlign;
  justify?: WxbGridJustify;
}

export interface WxbColProps extends React.HTMLAttributes<HTMLDivElement> {
  span?: WxbColSpan;
  tabletSpan?: WxbColSpan;
  mobileSpan?: WxbColSpan;
}

export interface WxbResponsiveGridProps extends React.HTMLAttributes<HTMLDivElement> {
  minItemWidth?: string;
  gap?: WxbGridGap;
}

const joinClasses = (...classes: Array<string | false | undefined>) =>
  classes.filter(Boolean).join(' ');

export const WxbRow: React.FC<WxbRowProps> = ({
  gap = 'md',
  align = 'stretch',
  justify = 'start',
  className = '',
  children,
  ...props
}) => (
  <div
    className={joinClasses(
      'wxb-row',
      `wxb-grid-gap-${gap}`,
      `wxb-row-align-${align}`,
      `wxb-row-justify-${justify}`,
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

export const WxbCol: React.FC<WxbColProps> = ({
  span = 12,
  tabletSpan,
  mobileSpan,
  className = '',
  style,
  children,
  ...props
}) => {
  const colStyle: StyleWithVars = {
    ...style,
    '--wxb-col-span': span,
    '--wxb-col-tablet-span': tabletSpan ?? span,
    '--wxb-col-mobile-span': mobileSpan ?? 12,
  };

  return (
    <div className={joinClasses('wxb-col', className)} style={colStyle} {...props}>
      {children}
    </div>
  );
};

export const WxbResponsiveGrid: React.FC<WxbResponsiveGridProps> = ({
  minItemWidth = '220px',
  gap = 'md',
  className = '',
  style,
  children,
  ...props
}) => {
  const gridStyle: StyleWithVars = {
    ...style,
    '--wxb-responsive-grid-min': minItemWidth,
  };

  return (
    <div
      className={joinClasses('wxb-responsive-grid', `wxb-grid-gap-${gap}`, className)}
      style={gridStyle}
      {...props}
    >
      {children}
    </div>
  );
};

